import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/mh_w_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4dc11582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"dvTop\" data-v-4dc11582><div class=\"dvTopLeft\" data-v-4dc11582><div class=\"dvTopLeftLogo\" data-v-4dc11582><img src=\"" + _imports_0 + "\" alt=\"机灵树\" data-v-4dc11582></div><div class=\"dvTopLeftTitle\" data-v-4dc11582>· 艺术素质测评系统</div></div></div>", 1)
const _hoisted_3 = { class: "dvMid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvMidTitle mt15" }, "点击按钮即可开始测评", -1))
const _hoisted_5 = { class: "dvBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("button", {
        class: "mt2 btnGoToExam",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToExam && _ctx.goToExam(...args)))
      }, "进入测评")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "mb3 mr2 btnGoBack",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, "返 回")
    ])
  ]))
}